export default __webpack_public_path__ + "static/media/About_illust.0210c04b.png";